export const MediaState = {
  errorMessage: '',
  isLoading: false,
  media: {},
  wasStopped: true,
  args: {}
};



/** WEBPACK FOOTER **
 ** ./model/mediaState.js
 **/